import React, { useCallback, useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import { ExpandMore } from '@mui/icons-material';
import './tradingInfluence.scss';
import { DefaultBlot, DoubleCoin, Warning } from 'src/assets';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const TradingInfluence = () => {
  const { t } = useTranslation();

  const [isExpandedVolatility, setIsExpandedVolatility] = useState(true);
  const [isExpandedPrice, setIsExpandedPrice] = useState(false);
  const [isExpandedSeason, setIsExpandedSeason] = useState(false);

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  const renderAccordion = useCallback(
    (expanded, onChange, title, subtitle) => {
      return (
        <Accordion
          className={`trading-accordion ${expanded ? 'active-accordion' : ''}`}
          disableGutters
          expanded={expanded}
          onChange={() => onChange((prev) => !prev)}
        >
          <AccordionSummary className="trading-accordion-summary" expandIcon={<ExpandMore />}>
            <h3>{t(title)}</h3>
          </AccordionSummary>
          <AccordionDetails className="trading-accordion-details">
            <text>
              <Trans i18nKey={subtitle} />
            </text>
          </AccordionDetails>
        </Accordion>
      );
    },
    [t],
  );

  return (
    <div className="trading-influence">
      <div className={`trading-influence-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="trading-influence-title">
          <supertitle>{t('tradingInfluence:supertitle')}</supertitle>
          <h1>
            <blue-text>{t('tradingInfluence:peculiarities')}</blue-text>{' '}
            {t('tradingInfluence:inluence')}
            <br />
            <blue-underline>{t('tradingInfluence:session')}</blue-underline>
          </h1>
        </div>
        <div className="trading-influence-section">
          <div className="trading-influence-section-left">
            <div className="trading-influence-coins">
              <img src={DoubleCoin} alt={DoubleCoin} className="trading-influence-coins-image" />
              <img src={DefaultBlot} alt={DefaultBlot} className="trading-influence-image-1" />
            </div>
            <div className="trading-influence-warning">
              <img src={Warning} alt={Warning} />
              <text>{t('tradingInfluence:warning')}</text>
            </div>
          </div>
          <div>
            {renderAccordion(
              isExpandedVolatility,
              setIsExpandedVolatility,
              'tradingInfluence:volativityTitle',
              'tradingInfluence:volativitySub',
            )}
            {renderAccordion(
              isExpandedPrice,
              setIsExpandedPrice,
              'tradingInfluence:priceTitle',
              'tradingInfluence:priceSub',
            )}
            {renderAccordion(
              isExpandedSeason,
              setIsExpandedSeason,
              'tradingInfluence:seasonTitle',
              'tradingInfluence:seasonSub',
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
